// API service functions for stores
import api from './client';

export interface Store {
  store_id: string;
  store_name: string;
  store_type: string;
  description?: string;
  connection_config?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  org_id: string; // Added to identify which organization the store belongs to
}

export interface StoreCreate {
  store_id: string;
  store_name: string;
  store_type: string;
  description?: string;
  connection_config?: string;
}

export interface StoreUpdate {
  store_name?: string;
  store_type?: string;
  description?: string;
  connection_config?: string;
  is_active?: boolean;
}

export const storeApi = {
  create: async (data: StoreCreate): Promise<Store> => {
    const response = await api.post('/v1/stores/', data);
    return response.data;
  },

  list: async (skip = 0, limit = 100): Promise<Store[]> => {
    const response = await api.get(`/v1/stores/?skip=${skip}&limit=${limit}`);
    return response.data;
  },

  listByOrg: async (orgId: string): Promise<Store[]> => {
    const response = await api.get(`/v1/stores/org/${orgId}`);
    return response.data;
  },

  get: async (id: number): Promise<Store> => {
    const response = await api.get(`/v1/stores/${id}`);
    return response.data;
  },

  update: async (id: number, data: StoreUpdate): Promise<Store> => {
    const response = await api.put(`/v1/stores/${id}`, data);
    return response.data;
  },

  disable: async (id: number): Promise<{ message: string }> => {
    const response = await api.delete(`/v1/stores/${id}`);
    return response.data;
  }
};
